export default __webpack_public_path__ + "static/NotoSerif-BoldItalic-6f32e263f69d8e4b6a27eace713a056b.ttf";